import { Menu } from "antd"
import Link from "next/link"
import {
  EyeOutlined
} from "@ant-design/icons"
import PropTypes from "prop-types"
import ConfidentialityDisclaimer from "../confidentiality-disclaimer"

ImplementerAttendanceMonitorMenu.propTypes = {
  step: PropTypes.any,
  submenu: PropTypes.any
}

export function ImplementerAttendanceMonitorMenu({ step, submenu }) {
  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline">
        <Menu.SubMenu
          key="projects"
          icon={<EyeOutlined />}
          title="Proyectos">
          <Menu.Item key="active">
            <Link href="/implementer/projects">
              Activos
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}
